// extracted by mini-css-extract-plugin
module.exports = {"form":"resources-module--form--XB9Zn","sidebar":"resources-module--sidebar--Q-BNe","rightSidebar":"resources-module--rightSidebar--3Q6Wa"};